import { config } from '../constants/domainConfig';
import Logo from '../assets/logos/logo-movio.svg';
import LogoEntertainu from '../assets/logos/entertainu_w.svg';
import LogoFunbox from '../assets/logos/funbox.svg';
import LogoFlixvid from '../assets/logos/FLIXVID_LOGO.svg';
import LogoMixStreamFlix from '../assets/logos/MixStreamFlix_Logo.svg';
import LogoZvaigzdePlay from '../assets/logos/ZvaigzdePlay_Logo.png';
import LogoMobiotv from '../assets/logos/Mobiotv_Logo.png';
import LogoSparkStream from '../assets/logos/SparkStream_Logo.svg';
import Logozlataplay from '../assets/logos/ZlataPlay _logo.png';
import LogoNotionTv from '../assets/logos/nontontv_logo.svg';
import LogoMovioTvPulse from '../assets/logos/mobioplus_logo.svg';
import LogoPlaynixzone from '../assets/logos/playnixzone_logo.png';
import LogoSorottv from '../assets/logos/sorottv_logo.svg';
import LogoVidoros from '../assets/logos/vidoros_logo.svg';

export const getLogo = () => {
    const logo =
        config.product === 'fun-box'
            ? LogoFunbox
            : config.product === 'entertainu'
              ? LogoEntertainu
              : config.product === 'flixvid'
                ? LogoFlixvid
                : config.product === 'mixstreamflix'
                  ? LogoMixStreamFlix
                  : config.product === 'zvaigzdeplay'
                    ? LogoZvaigzdePlay
                    : config.product === 'mobiotv'
                      ? LogoMobiotv
                      : config.product === 'sparkstream'
                        ? LogoSparkStream
                        : config.product === 'zlataplay'
                          ? Logozlataplay
                          : config.product === 'nonton-tv'
                            ? LogoNotionTv
                            : config.product === 'moviotv' && config.subdomain === 'plus'
                              ? LogoMovioTvPulse
                              : config.product === 'playnixzone'
                                ? LogoPlaynixzone
                                : config.product === 'sorottv'
                                  ? LogoSorottv
                                  : config.product === 'vidoros'
                                    ? LogoVidoros
                                    : Logo;
    return logo;
};

export const getCopyrightText = () => {
    const text =
        config.product === 'fun-box'
            ? '© Funbox'
            : config.product === 'entertainu'
              ? '© EntertainU'
              : config.product === 'flixvid'
                ? '© FlixVid'
                : config.product === 'mixstreamflix'
                  ? '© Mixstream Flix'
                  : config.product === 'zvaigzdeplay'
                    ? '© Zvaigzde Play'
                    : config.product === 'mobiotv'
                      ? '© Mobiotv'
                      : config.product === 'sparkstream'
                        ? '© SparkStream'
                        : config.product === 'zlataplay'
                          ? '© Zlataplay'
                          : config.product === 'nonton-tv'
                            ? '© Nonton Tv'
                            : config.product === 'moviotv'
                              ? '© moviotv'
                              : config.product === 'playnixzone'
                                ? '© Playnixzone'
                                : config.product === 'sorottv'
                                  ? '© sorottv'
                                  : config.product === 'vidoros'
                                    ? '© Vidoros'
                                    : '© Movio';
    return text;
};
